import { useContext } from 'react';
import { AppContext } from '@/contexts/app-context';
import { clsx } from 'clsx';

export const GoogleRecaptchaInfo = ({ darkMode = false }) => {
    const { language } = useContext(AppContext);

    const textClasses = clsx('r-text-sm styled-link', {
        'r-text-white': darkMode,
    });

    switch (language) {
        case 'sv':
            return (
                <div className={textClasses}>
                    <p>Den här webbplatsen skyddas av reCAPTCHA och Googles</p>
                    <a href="https://policies.google.com/privacy">Sekretesspolicy</a> och&nbsp;
                    <a href="https://policies.google.com/terms">Användarvillkor</a> gäller.
                </div>
            );
        case 'no':
            return (
                <div className={textClasses}>
                    <p>Denne nettsiden er beskyttet av reCAPTCHA og Googles</p>
                    <a href="https://policies.google.com/privacy">Personvern</a> og&nbsp;
                    <a href="https://policies.google.com/terms">brukervilkår</a> gjelder.
                </div>
            );
        case 'da':
            return (
                <div className={textClasses}>
                    <p>Denne hjemmeside er beskyttet af reCAPTCHA og Googles</p>
                    <a href="https://policies.google.com/privacy">Fortrolighedspolitik</a> og&nbsp;
                    <a href="https://policies.google.com/terms">Servicevilkår</a> gælder.
                </div>
            );
        case 'fi':
            return (
                <div className={textClasses}>
                    <p>Tämä sivusto on suojattu reCAPTCHA:lla ja Googlen</p>
                    <a href="https://policies.google.com/privacy">Tietosuojakäytäntö</a> ja&nbsp;
                    <a href="https://policies.google.com/terms">Käyttöehdot</a> ovat voimassa.
                </div>
            );
        default:
            return (
                <div className={textClasses}>
                    <p>This site is protected by reCAPTCHA and the Google</p>
                    <a href="https://policies.google.com/privacy">Privacy Policy</a> and&nbsp;
                    <a href="https://policies.google.com/terms">Terms of Service</a> apply.
                </div>
            );
    }
};
